import { QueryObserverResult, QueryObserverSuccessResult } from '@tanstack/query-core';
import { first, map, OperatorFunction } from 'rxjs';

/**
 * Filters and maps the first successful result of a query.
 * The observable will complete after the first successful result or throw an error if the source completed without emitting a successful result.
 *
 * @example
 * ```ts
 * const query = injectQuery()({ ... });
 *
 * query.result$
 *     .pipe(firstSuccessfulResult())
 *     .subscribe();
 * ```
 */
export function firstSuccessfulResult<T>(): OperatorFunction<
    QueryObserverResult<T>,
    QueryObserverSuccessResult<T>['data']
> {
    return (source$) =>
        source$.pipe(
            first(
                (result): result is QueryObserverSuccessResult<T> =>
                    result.isSuccess
            ),
            map((scanRequest) => scanRequest?.data)
        );
}
